<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage offer</p>
    </header>
    <section class="modal-card-body">
      <div class="columns">
        <div class="column">
          <b-field label="Label">
            <b-input
                type="text"
                v-model="offer.label"
                placeholder="e.g. Flat Rs. 50 off"
                required>
            </b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Amount">
            <b-input
                type="text"
                v-model.number="offer.amount"
                placeholder="e.g. 50"
                required>
            </b-input>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="Start date">
            <b-datepicker
              v-model="offer.startDate"
              placeholder="Click to select..."
              icon="calendar">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column">
          <b-field label="End date">
            <b-datepicker
              v-model="offer.endDate"
              placeholder="Click to select..."
              icon="calendar">
            </b-datepicker>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="Max. spent">
            <b-input
                type="text"
                v-model.number="offer.maxSpent"
                placeholder="e.g. 1000"
                required>
            </b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Min. spent">
            <b-input
                type="text"
                v-model.number="offer.minSpent"
                placeholder="e.g. 100"
                required>
            </b-input>
          </b-field>
        </div>
      </div>
      <div class="mt-2">
        <b-switch v-model="offer.active">Active</b-switch>        
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manage">Save</button>
    </footer>
  </div>
</template>

<script>
import moment from 'moment';
import OfferService from './service';

export default {
  name: 'manageOffer',

  props: ['propOffer', 'city'],

  created() {
    if (this.propOffer.docId) {
      this.offer = { ...this.propOffer };
      this.offer.startDate = moment(this.offer.startDate).toDate();
      this.offer.endDate = moment(this.offer.endDate).toDate();
    }
  },

  data() {
    return {
      isLoading: false,
      offer: {}
    };
  },

  methods: {
    manage() {
      this.isLoading = true;

      OfferService.manage(this.city.docId, this.offer).then(newOffer => {
        this.isLoading = false;
        const isNewOffer = !this.offer.docId;
        const offerObj = { ...this.offer };

        if (isNewOffer) {
          offerObj.id = this.offer.docId;
        }

        this.$bus.$emit('OFFER_UPDATE', offerObj, isNewOffer);
        this.$emit('close');
        this.$toast.open('Operation successfull');
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/hotel/Offers/ManageOffer.vue